import * as React from 'react';

export interface CustomEditRendererState {
    isEditMode: boolean;
    isDisabled: any;
    HVFlag: any;
}

var self;
export class GridDropdownHVCRenderer extends React.Component<any, CustomEditRendererState> {
    constructor(props: any) {
        super(props);

        this.state = {
            isEditMode: false,
            isDisabled: null,
            HVFlag: this.props.data.HVFlag
        };
        self = this;
    }

    componentDidMount() {
        this.setState({ isDisabled: false });

    }
    setSaveButtonDisabled(flag) {
        this.setState({ isDisabled: flag });
    }
    
   

    componentWillReceiveProps(nextprops: any) {


    }
    HVFlagChange(e) {

        var Value: string = e.currentTarget.value;
        this.setState({
            HVFlag: Value
        });
        const row = this.props.data;
        row.HVFlag = Value;
    }

    public render() {
        return <div>
            <select className='form-select' id="cBoxHVFlagChange" name="HVFlag" value={this.state.HVFlag}
                onChange={e => this.HVFlagChange(e)} >
                <option value="none">---None---</option>
                <option value="false">No</option>
                <option value="true">Yes</option>
            </select>
        </div>;
    }
}